import useMemory from "hooks/useMemory";

export default function rememberPage() {
  const memory = useMemory();
  memory.set("last_page", window?.location);
}
